"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CreativeFastStart {
    constructor({ enabled }) {
        this.toJSON = () => ({
            enabled: this.enabled,
        });
        this.enabled = enabled;
    }
}
CreativeFastStart.fromJSON = (json) => {
    const { enabled } = Object.assign({}, json);
    if (typeof enabled !== 'boolean')
        throw new Error('.enabled must be a boolean');
    return new CreativeFastStart({ enabled });
};
exports.default = CreativeFastStart;
